import React from 'react';

const PricingCard = ({ 
  title, 
  price, 
  period, 
  description, 
  features, 
  children,
  featured = false,
  badge = null,
  className = ''
}) => {
  return (
    <div className={`relative bg-white/80 backdrop-blur-sm rounded-2xl border border-white/20 p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${featured ? 'ring-2 ring-blue-500' : ''} ${className}`}>
      {badge && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-1 rounded-full text-sm font-semibold shadow-lg">
            {badge}
          </span>
        </div>
      )}
      
      <div className="text-center">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
        <div className="mb-6">
          <span className="text-5xl font-extrabold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
            ${price}
          </span>
          <span className="text-gray-600 ml-2">/{period}</span>
        </div>
        {description && (
          <p className="text-gray-600 mb-6">{description}</p>
        )}
        
        <ul className="text-left space-y-3 mb-8">
          {features.map((feature, index) => (
            <li key={index} className="flex items-center">
              <svg className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <span className="text-gray-700">{feature}</span>
            </li>
          ))}
        </ul>
        
        {children}
      </div>
    </div>
  );
};

export default PricingCard;